import { Flex } from '@osmosis/tailwind-ui/components/Box';
import NotePageContentsBlock from './blocks/NotesPageContentsBlock';
import { NoteContent } from '@elsevier-health/osmosis-shared/types/learndb/learnData';
import { H1 } from '@osmosis/tailwind-ui/components/Text';
import NotesPageInfoBlock from './blocks/NotesPageInfoBlock';
import NotesPageButtonsBlock from './blocks/NotesPageButtonsBlock';
interface NotesPageLeftSectionProps {
  contents?: NoteContent[];
  title: string;
  selectedPage: number;
  onSelectPage: (page: number) => void;
  isFullscreen: boolean;
  isDownloading: boolean;
  toggleFullscreen: () => void;
  handleDownload: () => void;
}

/**
 * Left section of the Notes page displaying the contents block,title and HYN info.
 */
const NotesPageLeftSection = ({
  contents,
  title,
  selectedPage,
  onSelectPage,
  isFullscreen,
  isDownloading,
  toggleFullscreen,
  handleDownload,
}: NotesPageLeftSectionProps) => {
  return (
    <Flex
      className="fixed left-4 top-4 h-screen w-1/4 flex-col overflow-y-auto pb-4"
      data-testid={'notesPage.leftsection'}
    >
      {!isFullscreen && <H1 className="pb-4">{title}</H1>}
      <NotesPageButtonsBlock
        isFullscreen={isFullscreen}
        toggleFullscreen={toggleFullscreen}
        isDownloading={isDownloading}
        handleDownload={handleDownload}
      />
      {!isFullscreen && (
        <>
          <NotePageContentsBlock
            contents={contents}
            selectedPage={selectedPage}
            onSelectPage={onSelectPage}
          />
          <NotesPageInfoBlock pageTitle={title} />
        </>
      )}
    </Flex>
  );
};

export default NotesPageLeftSection;
